module.exports = __webpack_public_path__ + "assets/img/bannoudesign-photo01.f7f96183.jpg";